import { FeatureTypes, SimpleActivityEventTypes } from '@eagle/data-function-types';
import { EventLocationData } from '@eagle/react-common';

interface ExcludedTripHistoryEvent {
  eventTypeId: string;
  feature?: string;
  featureTypeId: string;
}

export const EXCLUDED_TRIP_HISTORY_EVENTS: ExcludedTripHistoryEvent[] = [
  {
    eventTypeId: SimpleActivityEventTypes.START,
    feature: 'trip',
    featureTypeId: FeatureTypes.SIMPLE_ACTIVITY_V0,
  },
  {
    eventTypeId: SimpleActivityEventTypes.FINISH,
    feature: 'trip',
    featureTypeId: FeatureTypes.SIMPLE_ACTIVITY_V0,
  },
];

export const isExcludedTripHistoryEvent = (event: EventLocationData): boolean => {
  return EXCLUDED_TRIP_HISTORY_EVENTS.some((excludedEvent) => {
    if (excludedEvent.featureTypeId !== event.featureTypeId) return false;
    if (excludedEvent.eventTypeId !== event.eventTypeId) return false;
    if (typeof excludedEvent.feature === 'string' && excludedEvent.feature !== event.feature) return false;
    return true;
  });
};

export const filterExcludedTripHistoryEvents = (events: EventLocationData[]): EventLocationData[] => {
  return events.filter((event) => !isExcludedTripHistoryEvent(event));
};
